// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlayZonesShowcase_section__JSvbE {
  padding: 5rem 0;
  background: #fffbf7;
  position: relative;
  overflow: hidden;
}

/* Decorative floating elements */
.PlayZonesShowcase_section__JSvbE::before {
  content: '';
  position: absolute;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(251, 191, 36, 0.08), transparent 70%);
  top: 100px;
  right: -100px;
  pointer-events: none;
  animation: PlayZonesShowcase_drift__iF5yZ 10s ease-in-out infinite;
}

.PlayZonesShowcase_section__JSvbE::after {
  content: '';
  position: absolute;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 107, 157, 0.06), transparent 70%);
  bottom: 150px;
  left: -80px;
  pointer-events: none;
  animation: PlayZonesShowcase_drift__iF5yZ 8s ease-in-out infinite reverse;
}

.PlayZonesShowcase_inner__iTWhs {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 1.5rem;
  display: grid;
  gap: 1rem;
  position: relative;
  z-index: 1;
}

.PlayZonesShowcase_header__tYJBk {
  text-align: center;
  display: grid;
  gap: 0.5rem;
  margin-bottom: 2rem;
}

.PlayZonesShowcase_headerTag__NLoe6 {
  display: inline-flex;
  padding: 0.4rem 1rem;
  border-radius: 999px;
  background: linear-gradient(135deg, rgba(255, 209, 102, 0.35), rgba(255, 107, 157, 0.2));
  color: var(--color-primary-dark);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 0.75rem;
  border: 2px dashed rgba(255, 107, 157, 0.3);
  justify-self: center;
  animation: PlayZonesShowcase_wiggle__HSqrO 3s ease-in-out infinite;
}

.PlayZonesShowcase_header__tYJBk h2 {
  font-family: 'Fredoka', 'Poppins', sans-serif;
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  margin: 0;
}

/* Zone rows — slide in from left/right */
.PlayZonesShowcase_zoneRow__v6ATS {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  padding: 2.5rem 0;
  opacity: 0;
  transform: translateX(-60px);
  transition: opacity 0.7s ease, transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}

.PlayZonesShowcase_zoneRowReverse__n87Jb {
  transform: translateX(60px);
}

.PlayZonesShowcase_zoneRow__v6ATS.PlayZonesShowcase_visible__N8MXG {
  opacity: 1;
  transform: translateX(0);
}

.PlayZonesShowcase_zoneRowReverse__n87Jb .PlayZonesShowcase_zoneImage__9zJkH {
  order: 2;
}

.PlayZonesShowcase_zoneRowReverse__n87Jb .PlayZonesShowcase_zoneText__yW6JW {
  order: 1;
}

.PlayZonesShowcase_zoneImage__9zJkH {
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: 0 16px 40px rgba(124, 58, 237, 0.14);
  transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.5s ease;
}

.PlayZonesShowcase_zoneImage__9zJkH:hover {
  transform: scale(1.02) rotate(-1deg);
  box-shadow: 0 24px 56px rgba(124, 58, 237, 0.2);
}

.PlayZonesShowcase_zoneImage__9zJkH img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.PlayZonesShowcase_zoneImage__9zJkH:hover img {
  transform: scale(1.08);
}

.PlayZonesShowcase_zoneText__yW6JW h3 {
  font-family: 'Fredoka', 'Poppins', sans-serif;
  font-size: 1.6rem;
  margin: 0 0 0.75rem;
  color: var(--color-text);
  position: relative;
}

.PlayZonesShowcase_zoneText__yW6JW h3::after {
  content: '';
  display: block;
  width: 50px;
  height: 4px;
  border-radius: 2px;
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  margin-top: 0.5rem;
}

.PlayZonesShowcase_zoneText__yW6JW p {
  margin: 0 0 1.25rem;
  color: var(--color-text-muted);
  font-size: 1.05rem;
  line-height: 1.7;
}

/* Activity tag pills — bouncy entrance */
.PlayZonesShowcase_tagRow__HxK\\+K {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.PlayZonesShowcase_activityTag__kPSYn {
  display: inline-flex;
  align-items: center;
  padding: 0.45rem 1.1rem;
  border-radius: 999px;
  font-family: 'Fredoka', sans-serif;
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.02em;
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s ease;
  cursor: default;
}

.PlayZonesShowcase_activityTag__kPSYn:hover {
  transform: translateY(-3px) scale(1.08);
}

.PlayZonesShowcase_activityTag__kPSYn[data-color="pink"] {
  background: rgba(255, 107, 157, 0.15);
  color: var(--color-primary-dark);
  box-shadow: 0 4px 12px rgba(255, 107, 157, 0.15);
}

.PlayZonesShowcase_activityTag__kPSYn[data-color="pink"]:hover {
  box-shadow: 0 8px 20px rgba(255, 107, 157, 0.25);
}

.PlayZonesShowcase_activityTag__kPSYn[data-color="purple"] {
  background: rgba(124, 58, 237, 0.12);
  color: var(--color-secondary);
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.12);
}

.PlayZonesShowcase_activityTag__kPSYn[data-color="purple"]:hover {
  box-shadow: 0 8px 20px rgba(124, 58, 237, 0.2);
}

.PlayZonesShowcase_activityTag__kPSYn[data-color="turquoise"] {
  background: rgba(6, 182, 212, 0.12);
  color: #0891b2;
  box-shadow: 0 4px 12px rgba(6, 182, 212, 0.12);
}

.PlayZonesShowcase_activityTag__kPSYn[data-color="turquoise"]:hover {
  box-shadow: 0 8px 20px rgba(6, 182, 212, 0.2);
}

.PlayZonesShowcase_activityTag__kPSYn[data-color="yellow"] {
  background: rgba(251, 191, 36, 0.2);
  color: #b45309;
  box-shadow: 0 4px 12px rgba(251, 191, 36, 0.15);
}

.PlayZonesShowcase_activityTag__kPSYn[data-color="yellow"]:hover {
  box-shadow: 0 8px 20px rgba(251, 191, 36, 0.25);
}

/* Photo Gallery */
.PlayZonesShowcase_gallery__cTTYZ {
  margin-top: 3rem;
}

.PlayZonesShowcase_galleryTitle__K2ZFg {
  text-align: center;
  font-family: 'Fredoka', 'Poppins', sans-serif;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, var(--color-text), var(--color-secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.PlayZonesShowcase_galleryGrid__UQMG3 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
}

.PlayZonesShowcase_galleryItem__C6wX3 {
  aspect-ratio: 4/3;
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(124, 58, 237, 0.12);
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.PlayZonesShowcase_galleryItem__C6wX3:hover {
  transform: scale(1.06) rotate(-1deg);
  box-shadow: 0 16px 36px rgba(124, 58, 237, 0.22);
}

.PlayZonesShowcase_galleryItem__C6wX3 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@keyframes PlayZonesShowcase_drift__iF5yZ {
  0%, 100% { transform: translate(0, 0); }
  33% { transform: translate(20px, -15px); }
  66% { transform: translate(-15px, 10px); }
}

@keyframes PlayZonesShowcase_wiggle__HSqrO {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-2deg); }
  75% { transform: rotate(2deg); }
}

/* Responsive */
@media (max-width: 768px) {
  .PlayZonesShowcase_section__JSvbE {
    padding: 3rem 0;
  }

  .PlayZonesShowcase_zoneRow__v6ATS {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 1.5rem 0;
    transform: translateY(30px);
  }

  .PlayZonesShowcase_zoneRowReverse__n87Jb {
    transform: translateY(30px);
  }

  .PlayZonesShowcase_zoneRowReverse__n87Jb .PlayZonesShowcase_zoneImage__9zJkH {
    order: 0;
  }

  .PlayZonesShowcase_zoneRowReverse__n87Jb .PlayZonesShowcase_zoneText__yW6JW {
    order: 0;
  }
}

@media (max-width: 480px) {
  .PlayZonesShowcase_section__JSvbE {
    padding: 2.5rem 0;
  }

  .PlayZonesShowcase_inner__iTWhs {
    padding: 0 1rem;
  }

  .PlayZonesShowcase_headerTag__NLoe6 {
    font-size: 0.7rem;
    padding: 0.35rem 0.75rem;
  }

  .PlayZonesShowcase_zoneText__yW6JW h3 {
    font-size: 1.25rem;
  }

  .PlayZonesShowcase_zoneText__yW6JW p {
    font-size: 0.95rem;
  }

  .PlayZonesShowcase_activityTag__kPSYn {
    font-size: 0.75rem;
    padding: 0.3rem 0.75rem;
  }

  .PlayZonesShowcase_galleryGrid__UQMG3 {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
  }

  .PlayZonesShowcase_galleryTitle__K2ZFg {
    font-size: 1.25rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .PlayZonesShowcase_zoneRow__v6ATS,
  .PlayZonesShowcase_zoneRowReverse__n87Jb {
    opacity: 1;
    transform: none;
    transition: none;
  }

  .PlayZonesShowcase_activityTag__kPSYn,
  .PlayZonesShowcase_zoneImage__9zJkH,
  .PlayZonesShowcase_galleryItem__C6wX3 {
    transition: none;
  }

  .PlayZonesShowcase_activityTag__kPSYn:hover,
  .PlayZonesShowcase_zoneImage__9zJkH:hover,
  .PlayZonesShowcase_galleryItem__C6wX3:hover {
    transform: none;
  }

  .PlayZonesShowcase_headerTag__NLoe6 {
    animation: none;
  }

  .PlayZonesShowcase_section__JSvbE::before,
  .PlayZonesShowcase_section__JSvbE::after {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/home/PlayZonesShowcase.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,8EAA8E;EAC9E,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,kEAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,+EAA+E;EAC/E,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,yEAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,wFAAwF;EACxF,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;EACpB,kEAAyC;AAC3C;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;EACtC,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,4BAA4B;EAC5B,4EAA4E;AAC9E;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gDAAgD;EAChD,kFAAkF;AACpF;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,iFAAiF;EACjF,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kFAAkF;EAClF,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,iBAAiB;EACjB,qBAAqB;EACrB,8EAA8E;EAC9E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,+CAA+C;EAC/C,sDAAsD;AACxD;;AAEA;EACE,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,iCAAiC,EAAE;EACzC,MAAM,iCAAiC,EAAE;AAC3C;;AAEA;EACE,WAAW,uBAAuB,EAAE;EACpC,MAAM,wBAAwB,EAAE;EAChC,MAAM,uBAAuB,EAAE;AACjC;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".section {\n  padding: 5rem 0;\n  background: #fffbf7;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Decorative floating elements */\n.section::before {\n  content: '';\n  position: absolute;\n  width: 280px;\n  height: 280px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(251, 191, 36, 0.08), transparent 70%);\n  top: 100px;\n  right: -100px;\n  pointer-events: none;\n  animation: drift 10s ease-in-out infinite;\n}\n\n.section::after {\n  content: '';\n  position: absolute;\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(255, 107, 157, 0.06), transparent 70%);\n  bottom: 150px;\n  left: -80px;\n  pointer-events: none;\n  animation: drift 8s ease-in-out infinite reverse;\n}\n\n.inner {\n  max-width: var(--max-width);\n  margin: 0 auto;\n  padding: 0 1.5rem;\n  display: grid;\n  gap: 1rem;\n  position: relative;\n  z-index: 1;\n}\n\n.header {\n  text-align: center;\n  display: grid;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n}\n\n.headerTag {\n  display: inline-flex;\n  padding: 0.4rem 1rem;\n  border-radius: 999px;\n  background: linear-gradient(135deg, rgba(255, 209, 102, 0.35), rgba(255, 107, 157, 0.2));\n  color: var(--color-primary-dark);\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  border: 2px dashed rgba(255, 107, 157, 0.3);\n  justify-self: center;\n  animation: wiggle 3s ease-in-out infinite;\n}\n\n.header h2 {\n  font-family: 'Fredoka', 'Poppins', sans-serif;\n  font-size: clamp(1.75rem, 4vw, 2.5rem);\n  margin: 0;\n}\n\n/* Zone rows — slide in from left/right */\n.zoneRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  align-items: center;\n  padding: 2.5rem 0;\n  opacity: 0;\n  transform: translateX(-60px);\n  transition: opacity 0.7s ease, transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.zoneRowReverse {\n  transform: translateX(60px);\n}\n\n.zoneRow.visible {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.zoneRowReverse .zoneImage {\n  order: 2;\n}\n\n.zoneRowReverse .zoneText {\n  order: 1;\n}\n\n.zoneImage {\n  border-radius: var(--radius-xl);\n  overflow: hidden;\n  box-shadow: 0 16px 40px rgba(124, 58, 237, 0.14);\n  transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.5s ease;\n}\n\n.zoneImage:hover {\n  transform: scale(1.02) rotate(-1deg);\n  box-shadow: 0 24px 56px rgba(124, 58, 237, 0.2);\n}\n\n.zoneImage img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.6s ease;\n}\n\n.zoneImage:hover img {\n  transform: scale(1.08);\n}\n\n.zoneText h3 {\n  font-family: 'Fredoka', 'Poppins', sans-serif;\n  font-size: 1.6rem;\n  margin: 0 0 0.75rem;\n  color: var(--color-text);\n  position: relative;\n}\n\n.zoneText h3::after {\n  content: '';\n  display: block;\n  width: 50px;\n  height: 4px;\n  border-radius: 2px;\n  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));\n  margin-top: 0.5rem;\n}\n\n.zoneText p {\n  margin: 0 0 1.25rem;\n  color: var(--color-text-muted);\n  font-size: 1.05rem;\n  line-height: 1.7;\n}\n\n/* Activity tag pills — bouncy entrance */\n.tagRow {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.activityTag {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.45rem 1.1rem;\n  border-radius: 999px;\n  font-family: 'Fredoka', sans-serif;\n  font-weight: 600;\n  font-size: 0.8rem;\n  letter-spacing: 0.02em;\n  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s ease;\n  cursor: default;\n}\n\n.activityTag:hover {\n  transform: translateY(-3px) scale(1.08);\n}\n\n.activityTag[data-color=\"pink\"] {\n  background: rgba(255, 107, 157, 0.15);\n  color: var(--color-primary-dark);\n  box-shadow: 0 4px 12px rgba(255, 107, 157, 0.15);\n}\n\n.activityTag[data-color=\"pink\"]:hover {\n  box-shadow: 0 8px 20px rgba(255, 107, 157, 0.25);\n}\n\n.activityTag[data-color=\"purple\"] {\n  background: rgba(124, 58, 237, 0.12);\n  color: var(--color-secondary);\n  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.12);\n}\n\n.activityTag[data-color=\"purple\"]:hover {\n  box-shadow: 0 8px 20px rgba(124, 58, 237, 0.2);\n}\n\n.activityTag[data-color=\"turquoise\"] {\n  background: rgba(6, 182, 212, 0.12);\n  color: #0891b2;\n  box-shadow: 0 4px 12px rgba(6, 182, 212, 0.12);\n}\n\n.activityTag[data-color=\"turquoise\"]:hover {\n  box-shadow: 0 8px 20px rgba(6, 182, 212, 0.2);\n}\n\n.activityTag[data-color=\"yellow\"] {\n  background: rgba(251, 191, 36, 0.2);\n  color: #b45309;\n  box-shadow: 0 4px 12px rgba(251, 191, 36, 0.15);\n}\n\n.activityTag[data-color=\"yellow\"]:hover {\n  box-shadow: 0 8px 20px rgba(251, 191, 36, 0.25);\n}\n\n/* Photo Gallery */\n.gallery {\n  margin-top: 3rem;\n}\n\n.galleryTitle {\n  text-align: center;\n  font-family: 'Fredoka', 'Poppins', sans-serif;\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  background: linear-gradient(135deg, var(--color-text), var(--color-secondary));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.galleryGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n}\n\n.galleryItem {\n  aspect-ratio: 4/3;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: 0 8px 20px rgba(124, 58, 237, 0.12);\n  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.galleryItem:hover {\n  transform: scale(1.06) rotate(-1deg);\n  box-shadow: 0 16px 36px rgba(124, 58, 237, 0.22);\n}\n\n.galleryItem img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n@keyframes drift {\n  0%, 100% { transform: translate(0, 0); }\n  33% { transform: translate(20px, -15px); }\n  66% { transform: translate(-15px, 10px); }\n}\n\n@keyframes wiggle {\n  0%, 100% { transform: rotate(0deg); }\n  25% { transform: rotate(-2deg); }\n  75% { transform: rotate(2deg); }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .section {\n    padding: 3rem 0;\n  }\n\n  .zoneRow {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n    padding: 1.5rem 0;\n    transform: translateY(30px);\n  }\n\n  .zoneRowReverse {\n    transform: translateY(30px);\n  }\n\n  .zoneRowReverse .zoneImage {\n    order: 0;\n  }\n\n  .zoneRowReverse .zoneText {\n    order: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .section {\n    padding: 2.5rem 0;\n  }\n\n  .inner {\n    padding: 0 1rem;\n  }\n\n  .headerTag {\n    font-size: 0.7rem;\n    padding: 0.35rem 0.75rem;\n  }\n\n  .zoneText h3 {\n    font-size: 1.25rem;\n  }\n\n  .zoneText p {\n    font-size: 0.95rem;\n  }\n\n  .activityTag {\n    font-size: 0.75rem;\n    padding: 0.3rem 0.75rem;\n  }\n\n  .galleryGrid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n  }\n\n  .galleryTitle {\n    font-size: 1.25rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .zoneRow,\n  .zoneRowReverse {\n    opacity: 1;\n    transform: none;\n    transition: none;\n  }\n\n  .activityTag,\n  .zoneImage,\n  .galleryItem {\n    transition: none;\n  }\n\n  .activityTag:hover,\n  .zoneImage:hover,\n  .galleryItem:hover {\n    transform: none;\n  }\n\n  .headerTag {\n    animation: none;\n  }\n\n  .section::before,\n  .section::after {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `PlayZonesShowcase_section__JSvbE`,
	"drift": `PlayZonesShowcase_drift__iF5yZ`,
	"inner": `PlayZonesShowcase_inner__iTWhs`,
	"header": `PlayZonesShowcase_header__tYJBk`,
	"headerTag": `PlayZonesShowcase_headerTag__NLoe6`,
	"wiggle": `PlayZonesShowcase_wiggle__HSqrO`,
	"zoneRow": `PlayZonesShowcase_zoneRow__v6ATS`,
	"zoneRowReverse": `PlayZonesShowcase_zoneRowReverse__n87Jb`,
	"visible": `PlayZonesShowcase_visible__N8MXG`,
	"zoneImage": `PlayZonesShowcase_zoneImage__9zJkH`,
	"zoneText": `PlayZonesShowcase_zoneText__yW6JW`,
	"tagRow": `PlayZonesShowcase_tagRow__HxK+K`,
	"activityTag": `PlayZonesShowcase_activityTag__kPSYn`,
	"gallery": `PlayZonesShowcase_gallery__cTTYZ`,
	"galleryTitle": `PlayZonesShowcase_galleryTitle__K2ZFg`,
	"galleryGrid": `PlayZonesShowcase_galleryGrid__UQMG3`,
	"galleryItem": `PlayZonesShowcase_galleryItem__C6wX3`
};
export default ___CSS_LOADER_EXPORT___;
